import Pagination from './Pagination';
export default Pagination;


//////////////////
// WEBPACK FOOTER
// ./node_modules/.3.6.1@antd/es/pagination/index.js
// module id = 191
// module chunks = 1